import { render, staticRenderFns } from "./MultiChildrenVerticalMenuMini.vue?vue&type=template&id=dc3fd7ea&scoped=true"
import script from "./MultiChildrenVerticalMenuMini.vue?vue&type=script&lang=js"
export * from "./MultiChildrenVerticalMenuMini.vue?vue&type=script&lang=js"
import style0 from "./MultiChildrenVerticalMenuMini.vue?vue&type=style&index=0&id=dc3fd7ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3fd7ea",
  null
  
)

export default component.exports